import { Injectable, OnDestroy } from "@angular/core";
import { IGroupSummary } from "./remoteOrderGroupSummary.facade";
import { RemoteGroupOrderService } from "../../services/RemoteGroupOrder.service";
import { BehaviorSubject } from "rxjs";
import { ILocationData } from "../../services/IRemoteGroupOrderService";
import { LocationService } from "../location/location.service";
import { CoreLogService } from "../../services/log.service";


@Injectable()
export class RemoteOrderGroupSummaryService implements OnDestroy {

  constructor(private _remoteGroupOrderService: RemoteGroupOrderService
    , private _locationService: LocationService
    , private _coreLogService: CoreLogService
  ) { }

  ngOnDestroy(): void { }

  private _serviceTimeExpiredSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public ServiceTimeExpiredSubject = this._serviceTimeExpiredSubject.asObservable();

  public updateServiceTimeStatus(serviceTime: string): void {
    this._serviceTimeExpiredSubject.next(this._remoteGroupOrderService.serviceTimeNotValid(serviceTime));
  }

  public async loadGroupSummary(): Promise<IGroupSummary | null> {

    const groupSummary = await this._remoteGroupOrderService.getCacheGroupSummary();
    if (groupSummary) {
      try {
        const summary: IGroupSummary = {
          groupName: groupSummary.groupName,
          serviceTime: groupSummary.serviceTime,
          preOrdervariant: groupSummary.preOrdervariant,
          status: groupSummary.status,
          count: groupSummary.count,
          price: groupSummary.price,
          deliveryAddress: groupSummary.deliveryAddress,
          locationID: groupSummary.locationID,
        };
        console.log('Summary:', summary);
        return summary;

      } catch (error) {
        this.handleError("Error fetching group details:", error);
      }
    }
    return null;
  }

  public async loadLocationData(locationid: number): Promise<ILocationData | null> {
    try {
      const locationData = await this._locationService.GetWebshopLocationViewModelByID(locationid);
      if (!locationData) {
        return null;
      }
      const IlocationData: ILocationData = {
        name: locationData.label,
        street: locationData.street,
        zipCode: locationData.zip,
        city: locationData.location
      };
      return IlocationData;
    } catch (error) {
      this.handleError("Error loading location data:", error);
      return null;
    }
  }

  private handleError(message: string, error?: any) {
    const me = this;
    me._coreLogService.error("RemoteOrderGroupSummaryService", message, error);
  }

}
